import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import ArticleCard from '@/components/base/ArticleCard';
import CategoryTabs from '@/components/base/CategoryTabs';
import SEOSchema from '@/components/base/SEOSchema';
import { articles, categories } from '@/mocks/articles';

const ITEMS_PER_PAGE = 6;

export default function Home() {
  const [currentPage, setCurrentPage] = useState(1);
  const featuredArticles = articles.filter((a) => a.isHot).slice(0, 3);
  const latestArticles = articles.sort(
    (a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime()
  );
  const totalPages = Math.ceil(latestArticles.length / ITEMS_PER_PAGE);
  const paginatedArticles = latestArticles.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const hotArticles = articles
    .sort((a, b) => b.viewCount - a.viewCount)
    .slice(0, 5);

  return (
    <>
      <ScrollToTop />
      <SEOSchema type="Organization" />
      <SEOSchema type="WebSite" />
      <SEOSchema
        type="WebPage"
        data={{
          name: '黑料爆料 - 首页',
          url: 'https://heiliaobaoliao.com/',
        }}
      />

      <div className="min-h-screen bg-background-50 text-foreground-950">
        <Navbar />

        <main>
          {/* Hero Section */}
          <section className="relative pt-16">
            <div className="relative h-[420px] md:h-[560px] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20dramatic%20abstract%20red%20and%20black%20geometric%20pattern%20with%20glowing%20particles%2C%20cinematic%20noir%20aesthetic%2C%20dark%20moody%20atmosphere%2C%20modern%20minimal%20design%20with%20subtle%20light%20streaks%2C%20luxury%20dark%20textured%20background&width=1600&height=900&seq=hero-bg&orientation=landscape"
                alt="黑料爆料平台背景"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-background-50/70 via-background-50/50 to-background-50"></div>
              <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
                <div className="inline-flex items-center gap-2 bg-accent-500/20 border border-accent-500/30 rounded-full px-4 py-1.5 mb-6">
                  <i className="ri-fire-line text-accent-500"></i>
                  <span className="text-sm text-accent-500 font-semibold">实时更新 · 独家猛料</span>
                </div>
                <h1 className="text-3xl md:text-5xl lg:text-6xl font-black text-foreground-950 max-w-3xl leading-tight">
                  黑料爆料
                  <span className="block text-accent-500">独家猛料实时更新</span>
                </h1>
                <p className="mt-4 md:mt-6 text-sm md:text-base text-foreground-600 max-w-xl">
                  汇聚网络热议猛料，涵盖娱乐圈、网红、明星等各领域内幕信息，带你第一时间掌握最新黑料爆料动态
                </p>
                <div className="mt-6 md:mt-8 flex items-center gap-3">
                  <Link
                    to="/about"
                    className="px-6 py-3 bg-accent-500 text-white rounded-full font-semibold text-sm hover:bg-accent-600 transition-colors whitespace-nowrap"
                  >
                    立即爆料
                  </Link>
                  <Link
                    to="/category/dujia"
                    className="px-6 py-3 border border-foreground-300 text-foreground-700 rounded-full font-semibold text-sm hover:border-accent-500 hover:text-accent-500 transition-colors whitespace-nowrap"
                  >
                    独家猛料
                  </Link>
                </div>
              </div>
            </div>
          </section>

          {/* Category Navigation */}
          <section className="py-6 md:py-8">
            <div className="w-full max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
              <CategoryTabs categories={categories} activeSlug="all" />
            </div>
          </section>

          {/* Featured Articles */}
          <section className="pb-10 md:pb-14">
            <div className="w-full max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
              <div className="flex items-center justify-between mb-6">
                <div>
                  <h2 className="text-xl md:text-2xl font-bold text-foreground-950">
                    热门爆料
                  </h2>
                  <p className="text-sm text-foreground-500 mt-1">今日最受关注的猛料</p>
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                {featuredArticles.map((article, index) => (
                  <div key={article.id} className={index === 0 ? 'md:col-span-2 lg:col-span-2 md:row-span-2' : ''}>
                    <ArticleCard
                      article={article}
                      variant={index === 0 ? 'featured' : 'default'}
                    />
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Latest + Sidebar */}
          <section className="pb-10 md:pb-14">
            <div className="w-full max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
              <div className="flex flex-col lg:flex-row gap-8">
                {/* Main Content */}
                <div className="flex-1">
                  <div className="flex items-center justify-between mb-6">
                    <div>
                      <h2 className="text-xl md:text-2xl font-bold text-foreground-950">
                        最新爆料
                      </h2>
                      <p className="text-sm text-foreground-500 mt-1">实时追踪，不错过任何猛料</p>
                    </div>
                  </div>

                  <div className="space-y-5">
                    {paginatedArticles.map((article) => (
                      <Link
                        key={article.id}
                        to={`/article/${article.id}`}
                        className="group flex flex-col sm:flex-row gap-4 p-4 rounded-lg bg-background-100 border border-background-200/50 hover:border-accent-500/30 transition-all duration-300"
                      >
                        <div className="w-full sm:w-48 h-32 flex-shrink-0 rounded-lg overflow-hidden">
                          <img
                            src={article.imageUrl}
                            alt={article.imageAlt}
                            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                          />
                        </div>
                        <div className="flex-1 min-w-0 flex flex-col justify-between">
                          <div>
                            <div className="flex items-center gap-2 mb-1.5">
                              <span className="text-xs text-accent-500 font-medium bg-accent-500/10 px-2 py-0.5 rounded-full">
                                {article.category}
                              </span>
                              {article.isExclusive && (
                                <span className="text-xs bg-accent-500 text-white px-2 py-0.5 rounded-full font-bold">
                                  独家
                                </span>
                              )}
                            </div>
                            <h3 className="text-base md:text-lg font-semibold text-foreground-950 group-hover:text-accent-500 transition-colors line-clamp-2">
                              {article.title}
                            </h3>
                            <p className="mt-1.5 text-sm text-foreground-600 line-clamp-2">
                              {article.excerpt}
                            </p>
                          </div>
                          <div className="mt-3 flex items-center gap-4 text-xs text-foreground-500">
                            <span className="flex items-center gap-1">
                              <i className="ri-eye-line"></i>
                              {article.viewCount >= 10000 ? `${(article.viewCount / 10000).toFixed(1)}万` : article.viewCount}
                            </span>
                            <span className="flex items-center gap-1">
                              <i className="ri-message-2-line"></i>
                              {article.commentCount}
                            </span>
                            <span>{article.publishDate}</span>
                          </div>
                        </div>
                      </Link>
                    ))}
                  </div>

                  {/* Pagination */}
                  {totalPages > 1 && (
                    <nav className="mt-8 flex items-center justify-center gap-2" aria-label="分页导航">
                      <button
                        onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                        disabled={currentPage === 1}
                        className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-100 border border-background-200/50 text-foreground-600 hover:text-accent-500 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
                      >
                        <i className="ri-arrow-left-s-line"></i>
                      </button>
                      {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                        <button
                          key={page}
                          onClick={() => setCurrentPage(page)}
                          className={`w-10 h-10 flex items-center justify-center rounded-lg text-sm font-medium transition-colors ${
                            currentPage === page
                              ? 'bg-accent-500 text-white'
                              : 'bg-background-100 border border-background-200/50 text-foreground-600 hover:text-accent-500'
                          }`}
                        >
                          {page}
                        </button>
                      ))}
                      <button
                        onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
                        disabled={currentPage === totalPages}
                        className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-100 border border-background-200/50 text-foreground-600 hover:text-accent-500 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
                      >
                        <i className="ri-arrow-right-s-line"></i>
                      </button>
                    </nav>
                  )}
                </div>

                {/* Sidebar */}
                <aside className="w-full lg:w-80 flex-shrink-0">
                  <div className="sticky top-20 space-y-6">
                    {/* Hot Ranking */}
                    <div className="bg-background-100 border border-background-200/50 rounded-lg p-5">
                      <h3 className="text-base font-bold text-foreground-950 flex items-center gap-2">
                        <i className="ri-fire-line text-accent-500"></i>
                        热门排行
                      </h3>
                      <div className="mt-4 space-y-1">
                        {hotArticles.map((article, index) => (
                          <Link
                            key={article.id}
                            to={`/article/${article.id}`}
                            className="flex items-start gap-3 p-2 rounded-md hover:bg-background-50 transition-colors group"
                          >
                            <span
                              className={`w-6 h-6 flex items-center justify-center rounded-full text-xs font-bold flex-shrink-0 ${
                                index < 3
                                  ? 'bg-accent-500 text-white'
                                  : 'bg-background-200 text-foreground-500'
                              }`}
                            >
                              {index + 1}
                            </span>
                            <div className="min-w-0">
                              <p className="text-sm text-foreground-700 group-hover:text-accent-500 transition-colors line-clamp-2">
                                {article.title}
                              </p>
                              <span className="text-xs text-foreground-500 mt-1 block">
                                {article.viewCount >= 10000 ? `${(article.viewCount / 10000).toFixed(1)}万阅读` : `${article.viewCount}阅读`}
                              </span>
                            </div>
                          </Link>
                        ))}
                      </div>
                    </div>

                    {/* Tags Cloud */}
                    <div className="bg-background-100 border border-background-200/50 rounded-lg p-5">
                      <h3 className="text-base font-bold text-foreground-950 flex items-center gap-2">
                        <i className="ri-hashtag text-accent-500"></i>
                        热门标签
                      </h3>
                      <div className="mt-4 flex flex-wrap gap-2">
                        {['独家爆料', '娱乐圈', '明星八卦', '网红', '偷税漏税', '潜规则', '选秀黑幕', '数据造假', '直播带货', '偶像失格'].map(
                          (tag) => (
                            <span
                              key={tag}
                              className="text-xs text-foreground-600 bg-background-50 border border-background-200/50 px-3 py-1.5 rounded-full cursor-pointer hover:border-accent-500/30 hover:text-accent-500 transition-colors"
                            >
                              #{tag}
                            </span>
                          )
                        )}
                      </div>
                    </div>

                    {/* Submit Tip */}
                    <div className="bg-gradient-to-br from-accent-500/10 to-accent-500/5 border border-accent-500/20 rounded-lg p-5">
                      <h3 className="text-base font-bold text-foreground-950 flex items-center gap-2">
                        <i className="ri-megaphone-line text-accent-500"></i>
                        爆料投稿
                      </h3>
                      <p className="mt-2 text-sm text-foreground-600">
                        你有独家猛料？欢迎匿名投稿，我们严格保护爆料人隐私。
                      </p>
                      <Link
                        to="/about"
                        className="mt-3 inline-flex items-center gap-1.5 text-sm text-accent-500 font-semibold hover:text-accent-600 transition-colors"
                      >
                        立即投稿
                        <i className="ri-arrow-right-line"></i>
                      </Link>
                    </div>
                  </div>
                </aside>
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}